<script setup lang="ts">
/**
 * 基于 schema 自动生成的事件属性表单。
 * 当事件在 eventEditorSchema 中有字段定义但无专用编辑器时使用。
 */
import { computed } from 'vue'
import EventPropRow from '@/components/eventEditors/EventPropRow.vue'
import type EventBase from '@/model/EventClass/EventBase'
import EventEditorDefault from './EventEditorDefault.vue'
import EventFieldRenderer from './EventFieldRenderer.vue'
import { resolveEventEditorFields } from './eventEditorSchema'

const props = defineProps<{
  /** 当前编辑的事件实例 */
  event: EventBase
}>()

/** 根据事件 Code 解析出的可编辑字段列表。 */
const fields = computed(() => resolveEventEditorFields(props.event))
</script>

<template>
  <div v-if="fields.length" class="event-edit event-prop-form">
    <EventPropRow
      v-for="field in fields"
      :key="`${event.Code}-${field.key}`"
      :label="field.label"
      :align-start="field.control === 'textarea' || field.control === 'string-list' || field.control === 'resource-path'"
      :value-stack="field.control === 'textarea' || field.control === 'string-list' || field.control === 'resource-path'"
    >
      <EventFieldRenderer :event="event" :field="field" />
    </EventPropRow>
  </div>
  <EventEditorDefault v-else :event="event" />
</template>
